import { Header } from "../components/shared/Header";
import { Footer } from "../components/shared/Footer";
import { HomeHero } from "../components/home/HomeHero";
import { Solutions } from "../components/home/Solutions";
import { Security } from "../components/home/Security";
import { usePageMeta } from "../hooks/usePageMeta";
import { useJsonLd } from "../hooks/useJsonLd";
import { homeJsonLd } from "../lib/homeJsonLd";
import { SITE_URL } from "../lib/seo";
import content from "../data/content.json";

export default function HomePage() {
  usePageMeta(content.home.metaTitle, content.home.metaDescription, `${SITE_URL}/`);
  useJsonLd([homeJsonLd]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main data-testid="home-page" className="flex-1">
        <HomeHero />
        <Solutions />
        <Security />
      </main>
      <Footer />
    </div>
  );
}
